module.exports = [
	{
		"componentChunkName": "component---node-modules-gatsby-plugin-offline-app-shell-js",
		"layout": "layout---index",
		"layoutComponentChunkName": "component---src-layouts-index-jsx",
		"jsonName": "offline-plugin-app-shell-fallback.json",
		"path": "/offline-plugin-app-shell-fallback/"
	},
	{
		"componentChunkName": "component---src-templates-lesson-jsx",
		"layout": "layout---index",
		"layoutComponentChunkName": "component---src-layouts-index-jsx",
		"jsonName": "lesson-eight.json",
		"path": "/lesson-eight"
	},
	{
		"componentChunkName": "component---src-templates-lesson-jsx",
		"layout": "layout---index",
		"layoutComponentChunkName": "component---src-layouts-index-jsx",
		"jsonName": "lesson-eleven.json",
		"path": "/lesson-eleven"
	},
	{
		"componentChunkName": "component---src-templates-lesson-jsx",
		"layout": "layout---index",
		"layoutComponentChunkName": "component---src-layouts-index-jsx",
		"jsonName": "lesson-nine.json",
		"path": "/lesson-nine"
	},
	{
		"componentChunkName": "component---src-templates-lesson-jsx",
		"layout": "layout---index",
		"layoutComponentChunkName": "component---src-layouts-index-jsx",
		"jsonName": "lesson-ten.json",
		"path": "/lesson-ten"
	},
	{
		"componentChunkName": "component---src-templates-lesson-jsx",
		"layout": "layout---index",
		"layoutComponentChunkName": "component---src-layouts-index-jsx",
		"jsonName": "lesson-twelve.json",
		"path": "/lesson-twelve"
	},
	{
		"componentChunkName": "component---src-templates-lesson-jsx",
		"layout": "layout---index",
		"layoutComponentChunkName": "component---src-layouts-index-jsx",
		"jsonName": "lesson-five.json",
		"path": "/lesson-five"
	},
	{
		"componentChunkName": "component---src-templates-lesson-jsx",
		"layout": "layout---index",
		"layoutComponentChunkName": "component---src-layouts-index-jsx",
		"jsonName": "lesson-four.json",
		"path": "/lesson-four"
	},
	{
		"componentChunkName": "component---src-templates-lesson-jsx",
		"layout": "layout---index",
		"layoutComponentChunkName": "component---src-layouts-index-jsx",
		"jsonName": "1-dmgt-at-a-glance.json",
		"path": "/1-dmgt-at-a-glance"
	},
	{
		"componentChunkName": "component---src-templates-lesson-jsx",
		"layout": "layout---index",
		"layoutComponentChunkName": "component---src-layouts-index-jsx",
		"jsonName": "lesson-six.json",
		"path": "/lesson-six"
	},
	{
		"componentChunkName": "component---src-templates-lesson-jsx",
		"layout": "layout---index",
		"layoutComponentChunkName": "component---src-layouts-index-jsx",
		"jsonName": "lesson-three-code-of-conduct.json",
		"path": "/lesson-three-code-of-conduct"
	},
	{
		"componentChunkName": "component---src-templates-lesson-jsx",
		"layout": "layout---index",
		"layoutComponentChunkName": "component---src-layouts-index-jsx",
		"jsonName": "lesson-two-scope-and-responsibilities.json",
		"path": "/lesson-two-scope-and-responsibilities"
	},
	{
		"componentChunkName": "component---src-templates-lesson-jsx",
		"layout": "layout---index",
		"layoutComponentChunkName": "component---src-layouts-index-jsx",
		"jsonName": "one-to-delete.json",
		"path": "/one-to-delete"
	},
	{
		"componentChunkName": "component---src-templates-lesson-jsx",
		"layout": "layout---index",
		"layoutComponentChunkName": "component---src-layouts-index-jsx",
		"jsonName": "lesson-seven.json",
		"path": "/lesson-seven"
	},
	{
		"componentChunkName": "component---src-templates-lesson-jsx",
		"layout": "layout---index",
		"layoutComponentChunkName": "component---src-layouts-index-jsx",
		"jsonName": "that-markdown-cheat.json",
		"path": "/that-markdown-cheat"
	},
	{
		"componentChunkName": "component---src-templates-post-jsx",
		"layout": "layout---index",
		"layoutComponentChunkName": "component---src-layouts-index-jsx",
		"jsonName": "post-one.json",
		"path": "/post-one"
	},
	{
		"componentChunkName": "component---src-templates-post-jsx",
		"layout": "layout---index",
		"layoutComponentChunkName": "component---src-layouts-index-jsx",
		"jsonName": "newest-post.json",
		"path": "/newest-post"
	},
	{
		"componentChunkName": "component---src-templates-post-jsx",
		"layout": "layout---index",
		"layoutComponentChunkName": "component---src-layouts-index-jsx",
		"jsonName": "new-post.json",
		"path": "/new-post"
	},
	{
		"componentChunkName": "component---src-templates-category-jsx",
		"layout": "layout---index",
		"layoutComponentChunkName": "component---src-layouts-index-jsx",
		"jsonName": "categories-tech.json",
		"path": "/categories/tech/"
	},
	{
		"componentChunkName": "component---src-pages-about-jsx",
		"layout": "layout---index",
		"layoutComponentChunkName": "component---src-layouts-index-jsx",
		"jsonName": "about.json",
		"path": "/about/"
	},
	{
		"componentChunkName": "component---src-pages-index-jsx",
		"layout": "layout---index",
		"layoutComponentChunkName": "component---src-layouts-index-jsx",
		"jsonName": "index.json",
		"path": "/"
	}
];


//////////////////
// WEBPACK FOOTER
// ./.cache/pages.json
// module id = 420
// module chunks = 231608221292675